import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-levelup-dialog',
  templateUrl: './levelup-dialog.component.html',
  styleUrls: ['./levelup-dialog.component.css']
})
export class LevelupDialogComponent implements OnInit {
  showGifIcon:any = true;
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<LevelupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    setTimeout(() => { 
      this.dialogRef.close(true);
    }, 5000);
    this.disableGifIcon();
  }

  disableGifIcon(){
    setTimeout(() => {
      this.showGifIcon = false;
    }, 1000);
  }

  close() {
    this.dialogRef.close(true);
  }

}
